import { render } from "./ModulePersonalizationBanner.vue?vue&type=template&id=22b89e24&scoped=true"
import script from "./ModulePersonalizationBanner.vue?vue&type=script&lang=js"
export * from "./ModulePersonalizationBanner.vue?vue&type=script&lang=js"

import "./ModulePersonalizationBanner.vue?vue&type=style&index=0&id=22b89e24&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b89e24"]])

export default __exports__